import React from "react";
import { Wallet, Activity, CheckCheck, Scale, BadgeCheck, CreditCard } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common";
import { FEATURES } from "@/data/content";

const ICON_MAP = { Wallet, Activity, CheckCheck, Scale, BadgeCheck, CreditCard };

export const FeaturesSection = () => {
  return (
    <section id="features" data-testid="features-section" className="relative py-20 sm:py-28 bg-[#f7faf8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading overline="Features" title="Everything you need before the work begins." center />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => {
            const Icon = ICON_MAP[f.icon];
            return (
              <Reveal key={f.title} delay={(i % 3) * 0.07}>
                <div
                  data-testid={`feature-card-${i}`}
                  className="group h-full bg-white rounded-3xl border border-slate-100 soft-shadow p-8 transition-transform duration-300 hover:-translate-y-1.5"
                >
                  <div
                    className="h-14 w-14 rounded-2xl flex items-center justify-center mb-6 transition-transform duration-300 group-hover:scale-110"
                    style={{ background: f.tint }}
                  >
                    <Icon className="h-7 w-7" style={{ color: f.color }} />
                  </div>
                  <h3 className="font-display text-xl font-bold text-[#091630] mb-2">{f.title}</h3>
                  <p className="text-[15px] text-slate-500 leading-relaxed">{f.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
